import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { TimeEntryArchiveStateClass } from './interfaces/TimeEntryArchiveStateClass'
import { sortData } from '../../../common/timeLiveFunction'

const initialState: TimeEntryArchiveStateClass = {
    isLoading: true,
    status: 'idle',
    timeEntryArchiveList: [],
    selectedRecord: {},
    isReload: false,
    currentPage: 1,
    // pageSize: 10,
    totalItems: 0,
    start: 0,
    // search: " ",
    recordsFiltered: 0,
    timeEntryArchiveCheckedIds: [],
    isAllUnChecked: true,
    optionClientNameValue: "0",
    optionClientNameText: "All",
    optionEmployeeNameValue: "0",
    optionEmployeeNameText: "All",
    optionProjectValue: "0",
    optionProjectText: "All",
    optionProjectTaskValue: "0",
    optionProjectTaskText: "All",
    optionApprovedValue: "-1",
    optionApprovedText: "Both",
    optionTimeEntryValue: "-1",
    optionTimeEntryText: "Both",
    startDate: new Date().toISOString(),
    endDate: new Date().toISOString(),
    columnIndex:0,
    direction:"asc",
    sortOrder: 'asc',
    sortColumn: 'TaskName',
    search: '',
    pageNo: 1,
    pageSize: 10

}
interface IThunkApi {
    state: {
        timeEntryArchive: TimeEntryArchiveStateClass;
    },
}
export const getTimeEntryArchiveForDatatableAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Timesheets/V2/getTimeEntryArchiveForDatatable',
        async (arg, thunkApi) => {
            const { currentPage, pageSize, start, search, SearchParamsValues } = arg;
            const encodedCurrentPage = encodeURIComponent(currentPage);
            const encodedPageSize = encodeURIComponent(pageSize);
            const encodedStart = encodeURIComponent(start);
            const trimmedSearchParamsValues = SearchParamsValues.trim();
            const encodedSearchParamsValues = encodeURIComponent(trimmedSearchParamsValues);
            const trimmedSearch = search.trim();
            const encodedSearch = encodeURIComponent(trimmedSearch);

            const encodedData = {
                currentPage:currentPage,
                pageSize:pageSize,
                start:start,
                SearchParamsValues:trimmedSearchParamsValues,
                search: trimmedSearch
              };
            //const url = 'api/V2/Timesheets/TimeEntryArchiveForDatatable/' + currentPage + '/' + pageSize + '/' + start + '/' + trimmedSearchParamsValues + '/' + encodedSearch;
            //console.log(url);

            const response = await fetchAPI(
                'api/V2/Timesheets/TimeEntryArchiveForDatatable/'+SearchParamsValues,
                'POST',
                encodedData,
                true,
                '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab'
            );
            //          const response = await fetchAPI('api/V2/Timesheets/TimeEntryArchiveForDatatable/' + currentPage + '/' + pageSize + '/' + start + '/' + SearchParamsValues + '/' + encodedSearch , 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
//UpdateTimeEntryArchive
export const updateTimeEntryArchiveAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Timesheets/V2/updateTimeEntryArchiveAsync',
        async (arg, thunkApi) => {
            //const {AccountLocationId} = arg;
            //const { AccountTaskTypeId, ...argWithoutId } = arg;
            const response = await fetchAPI('api/V2/Timesheets/UpdateTimeEntryArchive', 'PUT', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )
export const deleteAccountEmployeeTimeEntryAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'Timesheets/V2/deleteAccountEmployeeTimeEntry',
        async (arg, thunkApi) => {

            const response = await fetchAPI('api/V2/Timesheets/DeleteAccountEmployeeTimeEntry', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            //const response = await fetchAPI('api/Logs/ApiRecord/3C6268F0-C22B-4BBC-9555-58BFD1DA6B27' , 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

export const timeEntryArchiveSlice = createSlice({
    name: 'timeEntryArchive',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.timeEntryArchiveList = [];
            state.timeEntryArchiveCheckedIds = [];
        },
        checkedState: (state, action) => {
            const currentindex = state.timeEntryArchiveList.findIndex((item) => item.AccountEmployeeTimeEntryId == action.payload);
            const newArray = [...state.timeEntryArchiveList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
            state.timeEntryArchiveList = newArray;
            state.isAllUnChecked = false;
            //state.timeEntryArchiveCheckedIds.push(newArray[currentindex].AccountEmployeeTimeEntryId);
            state.timeEntryArchiveCheckedIds.push(newArray[currentindex]);


        },
        unCheckedState: (state, action) => {
            const currentindex = state.timeEntryArchiveList.findIndex((item) => item.AccountEmployeeTimeEntryId == action.payload);
            const newArray = [...state.timeEntryArchiveList];
            newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
            state.timeEntryArchiveList = newArray;
            //state.timeEntryArchiveCheckedIds = state.timeEntryArchiveCheckedIds.filter(item => item !== newArray[currentindex].AccountEmployeeTimeEntryId);
            state.timeEntryArchiveCheckedIds = state.timeEntryArchiveCheckedIds.filter(item => item.AccountEmployeeTimeEntryId !== newArray[currentindex].AccountEmployeeTimeEntryId);


        },
        checkedAllState: (state) => {
            const newArray = state.timeEntryArchiveList.map((item) => ({
                ...item,
                isSelected: 1,
            }));
            state.timeEntryArchiveList = newArray;
            state.isAllUnChecked = false;
            state.timeEntryArchiveList.map((i) => {
                if (!state.timeEntryArchiveCheckedIds.includes(i)) {
                    state.timeEntryArchiveCheckedIds.push(i)
                }
                // if(!state.timeEntryArchiveCheckedIds.includes(i.AccountEmployeeTimeEntryId))
                // {
                //     state.timeEntryArchiveCheckedIds.push(i.AccountEmployeeTimeEntryId)
                // }
            });
        },
        unCheckedAllState: (state) => {
            const newArray = state.timeEntryArchiveList.map((item) => ({
                ...item,
                isSelected: 0,
            }));
            state.timeEntryArchiveList = newArray;
            state.isAllUnChecked = true;
            state.timeEntryArchiveList.map((i) => (
                //state.timeEntryArchiveCheckedIds = state.timeEntryArchiveCheckedIds.filter(item => item !== i.AccountEmployeeTimeEntryId )
                state.timeEntryArchiveCheckedIds = state.timeEntryArchiveCheckedIds.filter(item => item.AccountEmployeeTimeEntryId !== i.AccountEmployeeTimeEntryId)
            ));
        },
        checkAllCheckboxIsUncheckedState: (state) => {
            state.isAllUnChecked = state.timeEntryArchiveList.every((item) => item.isSelected === 0);

        },
        updatePagination: (state, action: PayloadAction<any>) => {
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
        updateSorting: (state, action) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            let tempArray = state.timeEntryArchiveList;
            state.timeEntryArchiveList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
        },
        Edit: (state, action) => {
            state.selectedRecord = action.payload;
        },
        setOptionClientNameValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionClientNameValue = value;
            state.optionClientNameText = label;
        },
        setOptionEmployeeNameValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionEmployeeNameValue = value;
            state.optionEmployeeNameText = label;
        },
        setOptionProjectValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionProjectValue = value;
            state.optionProjectText = label;
        },
        setOptionProjectTaskValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionProjectTaskValue = value;
            state.optionProjectTaskText = label;
        },
        setOptionApprovedValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionApprovedValue = value;
            state.optionApprovedText = label;
        },
        setOptionTimeEntryTypeValue: (state, action) => {
            const { value, label } = action.payload;
            state.optionTimeEntryValue = value;
            state.optionTimeEntryText = label;
        },        
        setDateRangeValue: (state, action) => {
            const { startDate, endDate } = action.payload;
            state.startDate = startDate;
            state.endDate = endDate;
        },
        setSearchValue: (state, action) => {

            state.search = action.payload;
            state.currentPage = 1;
        },
        setPageSizeValue: (state, action) => {
            state.pageSize = action.payload;
            state.currentPage = 1;
        },
        setSortConfig: (state, action) => {
            const {columnIndex,direction} = action.payload;
            let ndirection = 'asc';
            if (state.columnIndex === columnIndex && state.direction === 'asc') {
                ndirection = 'desc';
            }
            state.direction = ndirection;
            state.columnIndex = columnIndex;
           
         },
         

    },
    
    extraReducers: (builder) => {
        builder
            .addCase(getTimeEntryArchiveForDatatableAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true; // Set isLoading to true when request is pending
            })
            .addCase(getTimeEntryArchiveForDatatableAsync.fulfilled, (state, { payload }) => {
                
                state.status = 'idle';
                state.isLoading = false; // Set isLoading to false when request is fulfilled
    
                if (payload.data !== undefined) {
                    console.log('Time Entry Archive List :', JSON.parse(payload.data))
                    state.timeEntryArchiveList = JSON.parse(payload.data);
    
                    state.timeEntryArchiveList.forEach((item: any) => {
                        if (state.timeEntryArchiveCheckedIds.includes(item)) {
                            item.isSelected = 1;
                        } else {
                            item.isSelected = 0;
                        }
                        //item.AccountId = 14140;
                    });
    
                    state.isReload = false;
                    state.selectedRecord = {};
                    state.currentPage = payload.currentPage;
                    state.start = payload.start;
                    state.totalItems = payload.recordsTotal;
                    state.search = payload.search;
                    state.recordsFiltered = payload.recordsFiltered;
                }
            })
            .addCase(getTimeEntryArchiveForDatatableAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false; // Set isLoading to false when request is rejected
            })
    
            .addCase(deleteAccountEmployeeTimeEntryAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true; // Set isLoading to true when request is pending
            })
            .addCase(deleteAccountEmployeeTimeEntryAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false; // Set isLoading to false when request is fulfilled
                state.isReload = true;
                state.timeEntryArchiveCheckedIds = [];
            })
            .addCase(deleteAccountEmployeeTimeEntryAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false; // Set isLoading to false when request is rejected
            })
    
            .addCase(updateTimeEntryArchiveAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true; // Set isLoading to true when request is pending
            })
            .addCase(updateTimeEntryArchiveAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false; // Set isLoading to false when request is fulfilled
                state.isReload = true;
            })
            .addCase(updateTimeEntryArchiveAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false; // Set isLoading to false when request is rejected
            });
    }
})

export const {
    resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState, checkAllCheckboxIsUncheckedState,updateSorting, updatePagination, Edit,
    setOptionApprovedValue, setOptionClientNameValue, setOptionEmployeeNameValue, setOptionProjectTaskValue, setOptionProjectValue, setDateRangeValue,
    setSearchValue, setPageSizeValue,setSortConfig,setOptionTimeEntryTypeValue
} = timeEntryArchiveSlice.actions
export const TimeEntryArchiveState = (state: RootState) => state.timeEntryArchive
export default timeEntryArchiveSlice.reducer
